import { render, staticRenderFns } from "./BotAnalysis.vue?vue&type=template&id=180de74d&"
import script from "./BotAnalysis.vue?vue&type=script&lang=js&"
export * from "./BotAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BotAnalysis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports